// Stellt die Funktion im globalen Bereich zur Verfügung
window.checkDiscountGifts = function(discountCode) {
  // Initialisiere activeProducts Array, falls nicht vorhanden
  if (!this.activeProducts) this.activeProducts = [];
  else this.activeProducts = []; // Leere das Array für neue Durchläufe
  
  // Legacy activeGifts Array zur Abwärtskompatibilität
  if (!this.activeGifts) this.activeGifts = [];
  else this.activeGifts = [];
  
  // Verarbeite den Discount-Code
  let currentDiscountCode = '';
  if (discountCode) {
    currentDiscountCode = discountCode.trim().toLowerCase();
  } else {
    const discountInput = document.querySelector('input[name="discount"]');
    if (discountInput && discountInput.value) {
      currentDiscountCode = discountInput.value.trim().toLowerCase();
    }
  }
  
  // 1. Warenkorb auslesen
  let cartItems = [];
  let cartVariantIds = [];
  let cartProductIds = [];
  
  try {
    // Synchrone API-Abfrage, um den aktuellen Warenkorb zu erhalten
    const xhr = new XMLHttpRequest();
    xhr.open('GET', '/cart.js', false);
    xhr.send();
    
    if (xhr.status === 200) {
      const cartData = JSON.parse(xhr.responseText);
      if (cartData && cartData.items) {
        cartItems = cartData.items;
        cartVariantIds = cartItems.map(item => item.variant_id);
        cartProductIds = cartItems.map(item => item.product_id);
      }
    }
  } catch (error) {
    // Fallbacks für den Warenkorb
    if (this.itemsPaid && this.itemsPaid.length > 0) {
      cartItems = this.itemsPaid;
      cartVariantIds = cartItems.map(item => item.variant_id);
      cartProductIds = cartItems.map(item => item.product_id);
    } else if (window.cart?.items) {
      cartItems = window.cart.items;
      cartVariantIds = cartItems.map(item => item.variant_id);
      cartProductIds = cartItems.map(item => item.product_id);
    }
  }
  
  // 2. Verbesserte DOM-basierte Methode: Verwende die strukturierten Daten aus dem discount-gift-data Container
  try {
    // Hole alle Discount-Gift-Block Elemente aus dem Container
    const discountGiftData = document.getElementById('discount-gift-data');
    const discountGiftBlocks = [];
    
    if (discountGiftData) {
      const blockElements = discountGiftData.querySelectorAll('.discount-gift-block');
      
      blockElements.forEach((element, index) => {
        // Extrahiere die Daten aus den data-Attributen
        const blockId = element.getAttribute('data-block-id');
        const blockCode = element.getAttribute('data-block-code');
        
        // Parse JSON-formatierte Daten
        let products = [];
        try {
          const productsStr = element.getAttribute('data-products');
          products = productsStr ? JSON.parse(productsStr) : [];
        } catch (e) {
          // Fehler beim Parsen ignorieren
        }
        
        let mandatoryProducts = [];
        try {
          const mandatoryProductsStr = element.getAttribute('data-mandatory-products');
          mandatoryProducts = mandatoryProductsStr ? JSON.parse(mandatoryProductsStr) : [];
        } catch (e) {
          // Fehler beim Parsen ignorieren
        }
        
        const mandatoryAmount = element.getAttribute('data-mandatory-amount') || 'all';
        const freeFrom = element.getAttribute('data-free-from') || '';
        const freeUntil = element.getAttribute('data-free-until') || '';
        
        // Erstelle das Block-Objekt
        const block = {
          id: blockId,
          code: blockCode,
          products: products,
          mandatory_products: mandatoryProducts,
          mandatory_amount: mandatoryAmount,
          free_from: freeFrom,
          free_until: freeUntil
        };
        
        discountGiftBlocks.push(block);
      });
    }
    
    // 3. Analysiere die Pflichtprodukte für jeden gefundenen Block
    discountGiftBlocks.forEach((block, index) => {
      // PRÜFUNG: Rabattcode
      let discountCodeMatches = false;
      
      // Wenn der Block keinen Code hat, dann nehmen wir an, dass der aktuelle Code nicht gültig ist
      if (!block.code) {
        // Kein Code definiert, überspringe
      } else if (currentDiscountCode) {
        // Wenn ein Code definiert ist, prüfen wir die Übereinstimmung
        const validCodes = typeof block.code === 'string' ?
          block.code.split(',').map(c => c.trim().toLowerCase()) :
          (Array.isArray(block.code) ? block.code.map(c => String(c).trim().toLowerCase()) : [block.code.toString().toLowerCase()]);
        
        // Prüfe, ob einer der hinterlegten Codes im eingegebenen Code enthalten ist
        discountCodeMatches = validCodes.some(code => currentDiscountCode.includes(code));
        if (discountCodeMatches) {
          // Zeige, welcher Code gefunden wurde
          const matchingCode = validCodes.find(code => currentDiscountCode.includes(code));
          console.log(`[Code] Übereinstimmung gefunden: Hinterlegter Code "${matchingCode}" ist in "${currentDiscountCode}" enthalten`);
        }
      }
      
      // PRÜFUNG: Pflichtprodukte
      // Prüfe, ob alle oder mindestens eines der Pflichtprodukte im Warenkorb ist
      let requiredProductsInCart = false;
      
      // Nur prüfen, wenn Pflichtprodukte definiert sind
      if (!block.mandatory_products || block.mandatory_products.length === 0) {
        requiredProductsInCart = true;
      } else {
        // Extrahiere die Pflichtprodukt-IDs aus dem Block
        const mandatoryProductIds = Array.isArray(block.mandatory_products) ? 
          block.mandatory_products.map(product => {
            // Behandle sowohl einfache IDs als auch Objektformate
            if (typeof product === 'object' && product !== null) {
              return product.id || product.product_id;
            }
            return product;
          }) : 
          [block.mandatory_products];
        
        if (block.mandatory_amount === 'all') {
          // Alle Pflichtprodukte müssen im Warenkorb sein
          requiredProductsInCart = mandatoryProductIds.every(productId => cartProductIds.includes(parseInt(productId, 10)));
        } else {
          // Mindestens eines der Pflichtprodukte muss im Warenkorb sein
          requiredProductsInCart = mandatoryProductIds.some(productId => cartProductIds.includes(parseInt(productId, 10)));
        }
      }
      
      // ERGEBNIS: Wenn beide Bedingungen erfüllt sind, füge Geschenkprodukte hinzu
      if (requiredProductsInCart && discountCodeMatches) {
        // Direkt aus den Block-Daten extrahieren
        const giftProducts = block.products || [];
        
        if (giftProducts.length > 0) {
          giftProducts.forEach(product => {
            // Einheitliches Format für Geschenkprodukte
            let productId, title, variantId = null;
            
            if (typeof product === 'object' && product !== null) {
              // Vollständiges Produktobjekt
              productId = product.id || product.product_id;
              title = product.title || 'Unbekanntes Produkt';
              variantId = product.variant_id || 
                         (product.variants && product.variants.length > 0 ? product.variants[0].id : null);
            } else {
              // Einfache Produkt-ID
              productId = parseInt(product, 10);
              title = `Produkt ID ${productId}`;
            }
            
            if (productId) {
              // Produkt-Objekt erstellen
              const productObj = {
                block_id: block.id,
                product_id: productId,
                variant_id: variantId,
                title: title,
                quantity: 1,
                discount_code: currentDiscountCode
              };
              
              // In beide Arrays einfügen
              this.activeProducts.push(productObj);
              this.activeGifts.push(productObj);
            }
          });
        }
      }
    });
  } catch (error) {
    // Fehler ignorieren
  }
  
  if (this.activeProducts.length > 0) {
    // Wenn aktive Produkte gefunden wurden, rufe automatisch checkGiftProduct auf
    setTimeout(() => {
      this.checkGiftProduct();
    }, 100);
  }
  
  // Gib beide Arrays zurück, damit der Aufrufer flexibel ist
  return {
    activeProducts: this.activeProducts, 
    activeGifts: this.activeGifts
  };
}






// Funktion zum Prüfen und Hinzufügen von Geschenkprodukten zum Warenkorb
window.checkGiftProduct = function() {
  console.log('==== checkGiftProduct ====');
  
  // Prüfe, ob activeProducts existiert und Elemente enthält
  if (!this.activeProducts || this.activeProducts.length === 0) {
    console.log('[Info] Keine aktiven Geschenkprodukte vorhanden');
    return;
  }
  
  // 1. Aktuellen Warenkorb laden (gleiche Methode wie in checkDiscountGifts)
  let cartItems = [];
  let cartVariantIds = [];
  
  try {
    // Synchrone API-Abfrage
    const xhr = new XMLHttpRequest();
    xhr.open('GET', '/cart.js', false);
    xhr.send();
    
    if (xhr.status === 200) {
      const cartData = JSON.parse(xhr.responseText);
      if (cartData && cartData.items) {
        cartItems = cartData.items;
        cartVariantIds = cartItems.map(item => item.variant_id);
        console.log(`[Warenkorb] ${cartItems.length} Produkte gefunden`);
      }
    }
  } catch (error) {
    console.error('[Fehler] Warenkorb konnte nicht geladen werden:', error);
    return;
  }
  
  // 2. Jedes aktive Geschenkprodukt prüfen
  let productsToAdd = [];
  
  // Debug-Info für die gefundenen Produkte
  console.log('[Debug] Active Products:', JSON.stringify(this.activeProducts));
  
  // Zuerst einen Validierungsschritt durchführen, um zu prüfen, ob die Produkte im Shop existieren
  // Wir verwenden die aktuellen Warenkorb-Daten, um verfügbare Produkt-IDs zu sammeln
  let availableProductIds = [];
  let availableVariantIds = [];
  
  // 2a. Hole alle verfügbaren Produkte vom Shop und erstelle Mapping von Produkt-ID zu Varianten-ID
  let productToVariantMap = {}; // Map Produkt-ID -> erste Varianten-ID
  
  try {
    const productsXhr = new XMLHttpRequest();
    productsXhr.open('GET', '/products.json?limit=250', false);
    productsXhr.send();
    
    if (productsXhr.status === 200) {
      const productsData = JSON.parse(productsXhr.responseText);
      if (productsData && productsData.products) {
        console.log(`[Shop] ${productsData.products.length} Produkte im Shop gefunden`);
        
        // Extrahiere alle Produkt- und Varianten-IDs und erstelle Mapping
        productsData.products.forEach(product => {
          availableProductIds.push(product.id);
          
          if (product.variants && product.variants.length > 0) {
            // Speichere die erste Varianten-ID für diese Produkt-ID
            productToVariantMap[product.id] = product.variants[0].id;
            
            product.variants.forEach(variant => {
              availableVariantIds.push(variant.id);
            });
          }
        });
        
        console.log(`[Shop] ${availableProductIds.length} Produkt-IDs und ${availableVariantIds.length} Varianten-IDs verfügbar`);
        console.log('[Shop] Produkt zu Varianten Mapping erstellt');
      }
    }
  } catch (error) {
    console.error('[Shop] Fehler beim Laden der verfügbaren Produkte:', error);
  }
  
  // 2b. Jedes aktive Geschenkprodukt prüfen
  this.activeProducts.forEach((product, index) => {
    console.log(`[Produkt ${index+1}] Prüfe: ${product.title || 'Produkt ID: ' + product.product_id}`);
    
    // 1. Versuche zuerst die variant_id, falls vorhanden
    let idToUse;
    let idType = '';
    
    if (product.variant_id) {
      idToUse = Number(product.variant_id);
      idType = 'variant_id';
    } 
    // 2. Falls keine variant_id, aber eine product_id vorhanden ist und im Shop existiert
    else if (product.product_id && availableProductIds.includes(Number(product.product_id))) {
      // Wenn die Produkt-ID im Mapping existiert, verwende die entsprechende Varianten-ID
      if (productToVariantMap[product.product_id]) {
        idToUse = Number(productToVariantMap[product.product_id]);
        idType = 'erste Variante von product_id';
      } else {
        idToUse = Number(product.product_id);
        idType = 'product_id (keine Variante gefunden)';
      }
    } 
    // 3. Direkter Fallback auf product_id ohne Prüfung
    else if (product.product_id) {
      idToUse = Number(product.product_id);
      idType = 'product_id (nicht validiert)';
    }
    
    console.log(`[Produkt ${index+1}] Verwende ID: ${idToUse}, Typ: ${idType}`);
    
    // Prüfe, ob die ID eine gültige Variante ist
    const isValidVariant = availableVariantIds.includes(idToUse);
    
    // Prüfen, ob das Produkt bereits im Warenkorb ist
    if (!idToUse) {
      console.log(`[Produkt ${index+1}] Keine gültige ID gefunden - wird übersprungen ❌`);
    } else if (cartVariantIds.includes(idToUse)) {
      console.log(`[Produkt ${index+1}] Bereits im Warenkorb ✓`);
    } else if (isValidVariant) {
      console.log(`[Produkt ${index+1}] Nicht im Warenkorb - wird hinzugefügt ➕`);
      
      // Füge zum Array der hinzuzufügenden Produkte hinzu
      productsToAdd.push({
        id: idToUse,
        quantity: product.quantity || 1,
        properties: {
          '_gift': 'true',
          '_discount_code': product.discount_code || ''
        }
      });
    } else {
      console.log(`[Produkt ${index+1}] ID ${idToUse} ist keine gültige Variante - wird übersprungen ⚠️`);
    }
  });
  
  // 3. Hinzufügen der Produkte zum Warenkorb, falls notwendig
  if (productsToAdd.length > 0) {
    console.log(`[Aktion] Füge ${productsToAdd.length} Produkt(e) zum Warenkorb hinzu...`);
    
    // Fetch-API verwenden (keine jQuery-Abhängigkeit)
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: productsToAdd
      })
    })
    .then(response => {
      if (!response.ok) {
        return response.json().then(errorData => {
          console.error('[Error Details]', errorData);
          throw new Error(`HTTP error! Status: ${response.status}, Details: ${JSON.stringify(errorData)}`);
        });
      }
      return response.json();
    })
    .then(data => {
      console.log('[Erfolg] Produkte wurden zum Warenkorb hinzugefügt:', data);
      
      // Direkte Warenkorb-Neuladen-Strategie
      console.log('[Cart] Erzwinge Warenkorb-Aktualisierung...');
      
      // ERSTER ANSATZ: Versuche Alpine.js zu verwenden (falls vorhanden)
      if (window.Alpine) {
        console.log('[Cart] Alpine.js gefunden, versuche direkten Zugriff...');
        
        // Suche nach Alpine.js Komponenten, die den Warenkorb verwalten
        const alpineComponents = document.querySelectorAll('[x-data]');
        let alpineCartComponent = null;
        
        alpineComponents.forEach(component => {
          // Suche nach Komponenten mit Cart-relevanten Daten/Funktionen
          if (component.getAttribute('x-data').includes('cart') ||
              component.hasAttribute('data-cart-drawer')) {
            alpineCartComponent = component;
          }
        });
        
        if (alpineCartComponent) {
          console.log('[Cart] Alpine.js Cart-Komponente gefunden, versuche zu aktualisieren');
          
          // Versuche die Alpine.js Instanz zu bekommen
          const alpineInstance = window.Alpine.$data(alpineCartComponent);
          
          // Typische Alpine.js Methoden aufrufen
          if (alpineInstance) {
            if (typeof alpineInstance.refreshCart === 'function') {
              console.log('[Cart] Rufe Alpine refreshCart() auf');
              alpineInstance.refreshCart();
            } else if (typeof alpineInstance.getCart === 'function') {
              console.log('[Cart] Rufe Alpine getCart() auf');
              alpineInstance.getCart();
            }
          }
        }
      }
      
      // ZWEITER ANSATZ: Erzwinge Warenkorb-Neuzeichnung durch DOM-Manipulation
      console.log('[Cart] Versuche Warenkorb neu zu zeichnen...');
      
      // 1. Hole aktuelle Warenkorb-Daten
      fetch('/cart.js', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache'
        }
      })
      .then(response => response.json())
      .then(cart => {
        console.log('[Cart] Neue Warenkorb-Daten erhalten:', cart);
        
        // 2. Aktualisiere Warenkorb-Zähler im Header
        const cartCountElements = document.querySelectorAll('.cart-count, .cart-count-bubble, [data-cart-count], [data-cart-item-count]');
        const totalItems = cart.item_count;
        
        cartCountElements.forEach(element => {
          element.textContent = totalItems;
          // Zeige/Verstecke basierend auf Anzahl
          if (totalItems > 0) {
            element.classList.remove('hidden', 'count-zero', 'hidden-count');
          }
        });
        
        // 3. Erzwinge eine Neuladen des Cart-Drawers (falls offen)
        // Schritt 1: Suche alle möglichen Elemente, die einen Warenkorb öffnen könnten
        const cartToggles = document.querySelectorAll(
          'button[aria-controls="cart-drawer"], ' +
          '[data-action="open-drawer"][data-drawer-id="cart"], ' +
          '[data-cart-toggle], ' +
          '[data-drawer-toggle="cart"], ' +
          '.js-cart-trigger, ' +
          '#cart-icon-bubble, ' +
          '.cart-link'
        );
        
        if (cartToggles.length > 0) {
          console.log('[Cart] Warenkorb-Toggle gefunden, versuche zu klicken');
          // Klicke einmal, um den aktuellen Status zu ändern
          cartToggles[0].click();
          // Warte kurz und klicke erneut, um den Warenkorb wieder in seinen Ausgangszustand zu bringen
          setTimeout(() => cartToggles[0].click(), 1500);
        }
        
        // Als letzten Ausweg, forciere eine komplette Seiten-Aktualisierung nach 1 Sekunde
        console.log('[Cart] Lade die Seite in 3 Sekunden neu, falls der Warenkorb nicht sichtbar aktualisiert wurde');
        setTimeout(() => {
          // Frage den Nutzer, ob der Warenkorb aktualisiert wurde
        }, 3000);
      })
      .catch(error => {
        console.error('[Cart] Fehler beim Aktualisieren des Warenkorbs:', error);
        alert('Dein Geschenkprodukt wurde hinzugefügt! Bitte lade die Seite neu, um es im Warenkorb zu sehen.');
      });
    })
    .catch(error => {
      console.error('[Fehler] Produkte konnten nicht hinzugefügt werden:', error);
    });
  } else {
    console.log('[Info] Keine neuen Produkte zum Hinzufügen');
  }
};





/**
 * Verbesserte Funktion zum Verarbeiten von Rabattcodes
 * Diese Funktion wird vom Formular aufgerufen und sorgt dafür, dass erst die Geschenkprodukte
 * hinzugefügt werden, bevor der Checkout gestartet wird
 * 
 * @param {string} discountCode - Der eingegebene Rabattcode
 * @returns {void}
 */
window.handleDiscountSubmit = function(discountCode) {
  console.log('[Discount] Verarbeite Rabattcode:', discountCode);
  
  // 1. Rabattcode prüfen und Geschenkprodukte ermitteln
  const giftResult = window.checkDiscountGifts(discountCode);
  
  // 2. Warte kurz, bis die Geschenke zum Warenkorb hinzugefügt wurden
  if (giftResult && giftResult.activeProducts && giftResult.activeProducts.length > 0) {
    console.log('[Discount] Geschenkprodukte gefunden:', giftResult.activeProducts.length, 'Stück');
    
    // Checkout-Button Status aktualisieren
    if (window._setGiftProcessingState) {
      window._setGiftProcessingState(false, true);
    }
    
    // 3. Warte etwas, damit die Geschenke hinzugefügt werden können
    setTimeout(() => {
      // Warenkorb explizit neu laden
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          console.log('[Discount] Warenkorb neu geladen, löse cart-update Event aus');
          
          // WICHTIG: Explizites cart-update Event auslösen mit den neuesten Warenkorb-Daten
          window.dispatchEvent(
            new CustomEvent('cart-update', { 
              detail: { cart: cart } 
            })
          );
          
          // Checkout-Button Status wiederherstellen
          if (window._setGiftProcessingState) {
            window._setGiftProcessingState(false, false);
          }
          
          // Kurze Pause, damit der Warenkorb sich aktualisieren kann
          setTimeout(() => {
            // 4. Jetzt zum Checkout weiterleiten
            triggerAlpineCheckout(discountCode);
          }, 300);
        })
        .catch(err => {
          console.error('[Discount] Fehler beim Abrufen des Warenkorbs:', err);
          if (window._setGiftProcessingState) {
            window._setGiftProcessingState(false, false);
          }
          triggerAlpineCheckout(discountCode);
        });
    }, 1000);
  } else {
    // Wenn keine Geschenkprodukte gefunden wurden, direkt zum Checkout
    console.log('[Discount] Keine Geschenkprodukte gefunden, starte normalen Checkout');
    triggerAlpineCheckout(discountCode);
  }
};






/**
 * Hilfsfunktion zum Auslösen des Checkouts über Alpine.js
 * Sucht nach einer Alpine.js Komponente und ruft deren triggerCheckout Funktion auf
 * 
 * @param {string} discountCode - Der Rabattcode, der beim Checkout verwendet werden soll
 * @private
 */
function triggerAlpineCheckout(discountCode) {
  // Alpine-Komponente finden und triggerCheckout aufrufen
  const cartComponents = document.querySelectorAll('[x-data]');
  
  // Suche nach der richtigen Alpine-Komponente
  let found = false;
  cartComponents.forEach(component => {
    if (found) return;
    if (window.Alpine) {
      const alpineInstance = window.Alpine.$data(component);
      if (alpineInstance && typeof alpineInstance.triggerCheckout === 'function') {
        console.log('[Discount] Rufe Alpine triggerCheckout() auf');
        alpineInstance.triggerCheckout(discountCode);
        found = true;
      }
    }
  });
  
  // Fallback: Wenn keine passende Alpine-Komponente gefunden wurde
  if (!found) {
    console.log('[Discount] Keine Alpine-Komponente gefunden. Event auslösen...');
    window.dispatchEvent(new CustomEvent('trigger-checkout', { detail: { code: discountCode } }));
  }
}

/**
 * Überprüft, ob ein Buy X Get Y Discount aktiv ist und markiert das entsprechende Geschenk
 * Diese Funktion wird bei jeder Änderung im Warenkorb aufgerufen
 */
window.checkFreeDiscountProducts = function() {
  console.log('[checkFreeDiscountProducts] Start');
  
  // 1. Prüfe den aktuellen Warenkorb und den aktiven Rabattcode
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      // Hole den aktiven Rabattcode aus Alpine oder Cookie
      let activeDiscountCode = null;
      
      // Methode 1: Aus Alpine-Instanz
      if (window.Alpine) {
        const cartDrawerElements = document.querySelectorAll('[x-data][data-cart-drawer]');
        if (cartDrawerElements.length > 0) {
          try {
            const alpineInstance = window.Alpine.$data(cartDrawerElements[0]);
            console.log("[DEBUG] Alpine instance found:", alpineInstance);
            if (alpineInstance) {
              // Versuche verschiedene Eigenschaften zu prüfen, wo der Rabattcode gespeichert sein könnte
              if (alpineInstance.discountCodeInput) {
                activeDiscountCode = alpineInstance.discountCodeInput;
                console.log("[DEBUG] Discount code from discountCodeInput:", activeDiscountCode);
              } else if (alpineInstance.validDiscountCode) {
                activeDiscountCode = alpineInstance.validDiscountCode;
                console.log("[DEBUG] Discount code from validDiscountCode:", activeDiscountCode);
              } else if (alpineInstance.codeStatus === 'valid' && alpineInstance.discount > 0) {
                // Wenn ein gültiger Code ohne expliziten Namen vorhanden ist
                activeDiscountCode = "VALID_CODE_PRESENT";
                console.log("[DEBUG] Valid discount detected without specific code name");
              }
            }
          } catch (error) {
            console.error('[checkFreeDiscountProducts] Fehler beim Zugriff auf Alpine:', error);
          }
        }
      }
      
      // Methode 2: Aus Cookie
      if (!activeDiscountCode) {
        activeDiscountCode = _dsGetCookie("discount_code");
        if (activeDiscountCode) {
          console.log("[DEBUG] Discount code from cookie:", activeDiscountCode);
        }
      }
      
      // Methode 3: Prüfe, ob Rabatte angewendet wurden
      if (!activeDiscountCode && cart.total_discount > 0) {
        // Es gibt einen Rabatt, aber wir kennen den Code nicht
        activeDiscountCode = "DISCOUNT_APPLIED";
        console.log("[DEBUG] Discount detected from cart total_discount:", cart.total_discount);
      }
      
      // Methode 4: Prüfe Shopify Discount Applications
      if (!activeDiscountCode && cart.discount_applications && cart.discount_applications.length > 0) {
        const discountApp = cart.discount_applications[0];
        activeDiscountCode = discountApp.title || "SHOPIFY_DISCOUNT_APPLIED";
        console.log("[DEBUG] Discount from Shopify applications:", activeDiscountCode);
      }
      
      if (!activeDiscountCode) {
        console.log('[checkFreeDiscountProducts] Kein aktiver Rabattcode gefunden');
        
        // Als Debug-Ausgabe alle Elemente im Warenkorb anzeigen
        console.log('[DEBUG] Warenkorb Items:', cart.items);
        if (cart.items.length > 0) {
          cart.items.forEach((item, index) => {
            console.log(`[DEBUG] Item ${index+1}: ${item.title} (ID: ${item.product_id}, Variante: ${item.variant_id})`);
            console.log(`[DEBUG] Properties:`, item.properties);
          });
        }
        
        return;
      }
      
      console.log(`[checkFreeDiscountProducts] Aktiver Rabattcode: ${activeDiscountCode}`);
      
      // 2. Versuche, auf die gift-Blöcke direkt über Alpine.js zuzugreifen
      const discountGiftBlocks = [];
      
      console.log('[DEBUG] Suche nach Discount-Gift-Blöcken...');
      let alpineGifts = null;
      
      // Versuch 1: Zugriff auf die gifts-Variable im Alpine.js Scope
      if (window.Alpine) {
        const cartDrawerElements = document.querySelectorAll('[x-data][data-cart-drawer]');
        if (cartDrawerElements.length > 0) {
          try {
            const alpineInstance = window.Alpine.$data(cartDrawerElements[0]);
            if (alpineInstance && alpineInstance.gifts && Array.isArray(alpineInstance.gifts)) {
              alpineGifts = alpineInstance.gifts;
              console.log('[DEBUG] Alpine gifts gefunden:', alpineGifts);
            }
          } catch (error) {
            console.error('[DEBUG] Fehler beim Zugriff auf Alpine gifts:', error);
          }
        }
      }
      
      // Wenn Alpine-Gifts gefunden wurden, diese verwenden
      if (alpineGifts && alpineGifts.length > 0) {
        // Filtere die Blöcke nach dem aktiven Rabattcode
        alpineGifts.forEach(gift => {
          // Prüfe, ob der Code mit dem aktiven Rabattcode übereinstimmt
          if (gift.code) {
            const giftCodes = gift.code.split(',').map(c => c.trim().toUpperCase());
            console.log('[DEBUG] Gift block code:', giftCodes, 'Active code:', activeDiscountCode.toUpperCase());
            
            if (giftCodes.includes(activeDiscountCode.toUpperCase()) || 
                giftCodes.some(c => activeDiscountCode.toUpperCase().includes(c))) {
              console.log('[DEBUG] Matching gift block found:', gift);
              
              // Extrahiere die Produkt-IDs korrekt - berücksichtige verschiedene mögliche Strukturen
              let giftProductIds = [];
              
              // Debugging der Produktstruktur
              console.log('[DEBUG] Gift products structure:', JSON.stringify(gift.products));
              
              // Fall 1: Array von Objekten mit id-Eigenschaft
              if (Array.isArray(gift.products) && gift.products.length > 0 && typeof gift.products[0] === 'object') {
                giftProductIds = gift.products.map(product => {
                  // Versuche verschiedene ID-Formate zu finden
                  if (product.id) return product.id;
                  if (product.product_id) return product.product_id;
                  if (product.variant_id) return product.variant_id;
                  // Letzter Versuch: Nimm die erste numerische Eigenschaft
                  const firstNumericKey = Object.keys(product).find(key => !isNaN(parseInt(product[key])));
                  return firstNumericKey ? parseInt(product[firstNumericKey]) : null;
                }).filter(Boolean); // Filtere null-Werte heraus
              } 
              // Fall 2: Array von IDs
              else if (Array.isArray(gift.products) && gift.products.length > 0 && typeof gift.products[0] === 'number') {
                giftProductIds = gift.products;
              }
              // Fall 3: Einzelner Produkt-String oder Objekt
              else if (!Array.isArray(gift.products) && gift.products) {
                if (typeof gift.products === 'number') {
                  giftProductIds = [gift.products];
                } else if (typeof gift.products === 'object' && gift.products.id) {
                  giftProductIds = [gift.products.id];
                } else if (typeof gift.products === 'string' && !isNaN(parseInt(gift.products))) {
                  giftProductIds = [parseInt(gift.products)];
                }
              }
              
              console.log('[DEBUG] Extracted gift product IDs:', giftProductIds);
              
              // Konvertiere das Alpine-Gift-Format in unser Format
              discountGiftBlocks.push({
                id: gift.id,
                code: gift.code,
                requiredProducts: gift.mandatory_products || [],
                giftProducts: giftProductIds
              });
            }
          }
        });
      }
      
      // Versuch 2: Gift-Blöcke aus dem DOM extrahieren, wenn Alpine nicht funktioniert
      if (discountGiftBlocks.length === 0) {
        console.log('[DEBUG] Keine Alpine gifts gefunden, versuche DOM-Extraktion...');
        
        // Suche im DOM nach gift-block Elementen
        const giftBlockElements = document.querySelectorAll('.discount-gift-block, [data-gift-block-id]');
        console.log(`[DEBUG] ${giftBlockElements.length} potenzielle Gift-Block-Elemente gefunden`);
        
        // Sammle alle gift-product IDs
        const giftProductMap = {};
        document.querySelectorAll('[data-gift-product-id]').forEach(el => {
          const blockId = el.closest('[data-gift-block-id]')?.getAttribute('data-gift-block-id');
          const productId = parseInt(el.getAttribute('data-gift-product-id'), 10);
          
          if (blockId && productId && !isNaN(productId)) {
            if (!giftProductMap[blockId]) giftProductMap[blockId] = [];
            giftProductMap[blockId].push(productId);
          }
        });
        
        // Suche nach Discount-Codes in allen möglichen Elementen
        document.querySelectorAll('[data-discount-code], [data-code]').forEach(el => {
          const code = el.getAttribute('data-discount-code') || el.getAttribute('data-code');
          if (code) {
            const blockCodes = code.split(',').map(c => c.trim().toUpperCase());
            if (blockCodes.includes(activeDiscountCode.toUpperCase())) {
              // Finde die zugehörige Block-ID
              const blockId = el.getAttribute('data-block-id') || 
                             el.closest('[data-block-id]')?.getAttribute('data-block-id') ||
                             'dom-block-' + Math.random().toString(36).substring(2, 9);
                             
              // Extrahiere die Pflichtprodukte, falls möglich
              const mandatoryProducts = (el.getAttribute('data-mandatory-products') || '').split(',').filter(Boolean).map(id => parseInt(id, 10));
              
              // Finde die Gift-Produkte für diesen Block
              const giftProducts = giftProductMap[blockId] || [];
              
              if (giftProducts.length > 0) {
                discountGiftBlocks.push({
                  id: blockId,
                  code: code,
                  requiredProducts: mandatoryProducts,
                  giftProducts: giftProducts
                });
              }
            }
          }
        });
      }
      
      // Versuch 3: FALLBACK - Verwende die aktuellen Produkte im Warenkorb
      // Hier setzen wir alles in einen Promise-Chain, damit wir erst nach dem Fallback fortfahren
      const processBlocks = (blocks) => {
        // 3. Für jeden passenden Block prüfen, ob die erforderlichen Produkte im Warenkorb sind
        blocks.forEach(block => {
          const cartProductIds = cart.items.map(item => item.product_id);
          
          // Prüfe, ob alle erforderlichen Produkte im Warenkorb sind
          // Bei Fallback-Blöcken gehen wir davon aus, dass die Bedingungen erfüllt sind
          const allRequiredInCart = block.id === 'cart-fallback-block' || 
                                     block.requiredProducts.length === 0 ||
                                     block.requiredProducts.every(reqProdId => cartProductIds.includes(reqProdId));
          
          if (allRequiredInCart) {
            console.log(`[checkFreeDiscountProducts] Alle erforderlichen Produkte für Block ${block.id} sind im Warenkorb`);
            
            // 4. Suche die Geschenkprodukte im Warenkorb und markiere sie
            block.giftProducts.forEach(giftProdId => {
              const giftItem = cart.items.find(item => item.product_id === giftProdId);
              
              if (giftItem) {
                console.log(`[checkFreeDiscountProducts] Geschenkprodukt im Warenkorb gefunden: ${giftItem.title}`);
                
                // 5. Finde das DOM-Element und setze das Attribut
                setTimeout(() => {
                  const cartItems = document.querySelectorAll('.ds-cart-item, .ds-cart-item-container');
                  
                  // Finde das passende DOM-Element über Produkt-ID und Varianten-ID
                  let matchingItem = null;
                  
                  // Versuch 1: Über data-variant-id Attribut (präziseste Methode)
                  matchingItem = Array.from(cartItems).find(el => {
                    const variantId = el.getAttribute('data-variant-id');
                    return variantId && parseInt(variantId) === giftItem.variant_id;
                  });
                  
                  // Versuch 2: Über data-product-id Attribut
                  if (!matchingItem) {
                    matchingItem = Array.from(cartItems).find(el => {
                      const productId = el.getAttribute('data-product-id');
                      return productId && parseInt(productId) === giftItem.product_id;
                    });
                  }
                  
                  // Versuch 3: Fallback über Titel (weniger zuverlässig)
                  if (!matchingItem) {
                    matchingItem = Array.from(cartItems).find(el => {
                      const titleEl = el.querySelector('.ds-cart-item-title');
                      return titleEl && titleEl.textContent && titleEl.textContent.includes(giftItem.title);
                    });
                  }
                  
                  if (matchingItem) {
                    console.log(`[checkFreeDiscountProducts] DOM-Element für "${giftItem.title}" gefunden, setze free-item Attribut`);
                    matchingItem.setAttribute('free-item', 'true');
                    
                    // Stelle sicher, dass das gesamte Cart-Item sichtbar ist
                    matchingItem.style.display = 'flex';
                    
                    // Versuche, das Alpine.js-Datenmodell zu aktualisieren
                    if (window.Alpine) {
                      try {
                        // Hole die Alpine.js-Instanz für dieses Element
                        const alpineData = window.Alpine.$data(matchingItem.closest('[x-data]'));
                        
                        if (alpineData && alpineData.itemsPaid) {
                          // Finde das entsprechende Item im Alpine.js-Datenmodell
                          const variantId = parseInt(matchingItem.getAttribute('data-variant-id'));
                          const itemIndex = alpineData.itemsPaid.findIndex(item => item.variant_id === variantId);
                          
                          if (itemIndex !== -1) {
                            // Speichere den ursprünglichen Preis, falls noch nicht geschehen
                            if (!alpineData.itemsPaid[itemIndex]._originalPrice) {
                              alpineData.itemsPaid[itemIndex]._originalPrice = alpineData.itemsPaid[itemIndex].price;
                            }
                            
                            // Setze den Preis auf 0
                            alpineData.itemsPaid[itemIndex].price = 0;
                            
                            // Setze das free_item Property
                            if (!alpineData.itemsPaid[itemIndex].properties) {
                              alpineData.itemsPaid[itemIndex].properties = {};
                            }
                            alpineData.itemsPaid[itemIndex].properties._free_item = 'true';
                            
                            console.log('[checkFreeDiscountProducts] Alpine.js-Datenmodell aktualisiert, Preis auf 0 gesetzt');
                          }
                        }
                      } catch (error) {
                        console.error('[checkFreeDiscountProducts] Fehler beim Aktualisieren des Alpine.js-Datenmodells:', error);
                      }
                    }
                    
                    // Finde auch das Gratis-Label und setze das Attribut
                    const freeLabel = matchingItem.querySelector('.ds-cart-item-free');
                    if (freeLabel) {
                      freeLabel.setAttribute('free-item', 'true');
                      freeLabel.style.display = 'block'; // Stelle sicher, dass das Label sichtbar ist
                    }
                    
                    // Setze den Preis auf 0,00€
                    const priceElement = matchingItem.querySelector('.ds-cart-item-price');
                    if (priceElement) {
                      // Stelle sicher, dass das Preiselement sichtbar ist
                      priceElement.style.display = 'flex';
                      
                      // Speichere den ursprünglichen Preis als Attribut, falls er noch nicht gespeichert wurde
                      if (!priceElement.hasAttribute('data-original-price')) {
                        const originalPrice = priceElement.querySelector('.money')?.textContent || '';
                        priceElement.setAttribute('data-original-price', originalPrice);
                      }
                      
                      // Entferne alle vorhandenen Gratis-Texte, um Duplikate zu vermeiden
                      const existingFreeTexts = priceElement.querySelectorAll('p.tw-ml-4.tw-text-lg.tw-whitespace-nowrap.tw-font-bold.tw-text-\[\#387E2D\]');
                      existingFreeTexts.forEach(el => el.remove());
                      
                      // Verstecke die normalen Preisanzeigen
                      const normalPriceElements = priceElement.querySelectorAll('.tw-text-\[14px\].sm\:tw-whitespace-nowrap');
                      normalPriceElements.forEach(el => {
                        el.style.display = 'none';
                      });
                      
                      // Verstecke auch die "Du sparst"-Anzeige
                      const savingsElements = priceElement.querySelectorAll('[aria-label="savings"]');
                      savingsElements.forEach(el => {
                        el.style.display = 'none';
                      });
                      
                      // Zeige den Gratis-Text an
                      const freeTextTemplate = priceElement.querySelector('template[x-if="item.price == 0"]');
                      if (freeTextTemplate) {
                        // Nutze das vorhandene Template
                        const freeTextElement = document.createElement('p');
                        freeTextElement.className = 'tw-ml-4 tw-text-lg tw-whitespace-nowrap tw-font-bold tw-text-[#387E2D]';
                        freeTextElement.textContent = 'Gratis';
                        priceElement.appendChild(freeTextElement);
                      } else {
                        // Fallback: Erstelle ein eigenes Gratis-Element
                        const freeTextElement = document.createElement('p');
                        freeTextElement.className = 'tw-ml-4 tw-text-lg tw-whitespace-nowrap tw-font-bold tw-text-[#387E2D]';
                        freeTextElement.textContent = 'Gratis';
                        priceElement.appendChild(freeTextElement);
                      }
                    }
                    
                    // Füge eine Klasse hinzu, um das Item als Gratisprodukt zu markieren
                    matchingItem.classList.add('ds-free-gift-item');
                  } else {
                    console.log(`[checkFreeDiscountProducts] Kein DOM-Element für "${giftItem.title}" gefunden`);
                  }
                }, 200); // Kurze Verzögerung, um sicherzustellen, dass das DOM aktualisiert wurde
              }
            });
          } else {
            console.log(`[checkFreeDiscountProducts] Nicht alle erforderlichen Produkte für Block ${block.id} sind im Warenkorb`);
          }
        });
      };
      
      if (discountGiftBlocks.length > 0) {
        // Wenn wir bereits Blöcke gefunden haben, verarbeite sie direkt
        console.log('[DEBUG] Verarbeite gefundene Discount-Gift-Blöcke:', discountGiftBlocks);
        processBlocks(discountGiftBlocks);
      } else {
        // Sonst versuche den Fallback
        console.log('[DEBUG] Keine Discount-Blöcke gefunden, suche direkt im Warenkorb...');
        
        // Verwende Promise-Chain, um sicherzustellen, dass die Fallback-Logik abgeschlossen ist,
        // bevor wir fortfahren
        fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            // Wenn mindestens zwei verschiedene Produkte im Warenkorb sind (1 reguläres + 1 Geschenk)
            if (cart.items.length >= 2) {
              // Suche nach einem potenziellen Gratisprodukt
              // Präzisiere die Kriterien für Geschenkprodukte:
              // - Ausschließliche Duschbrocken Minis (nicht FAIRpackung)
              // - Eindeutige Gratis-Angebote
              const potentialGiftProducts = cart.items.filter(item => {
                const title = item.title.toUpperCase();
                
                // Spezifische Duschbrocken Minis identifizieren
                if (title.includes('DUSCHBROCKEN MINIS') || 
                    title.includes('DUSCHBROCKEN MINI')) {
                  return true;
                }
                
                // Eindeutige Kennzeichen für Gratisprodukte
                return title.includes('GRATIS') || 
                       title.includes('FREE GIFT') || 
                       title.includes('KOSTENLOS');
              });
              
              // Suche nach einem potenziellen required product
              const potentialRequiredProducts = cart.items.filter(item => 
                !potentialGiftProducts.some(giftItem => giftItem.variant_id === item.variant_id)
              );
              
              if (potentialGiftProducts.length > 0 && potentialRequiredProducts.length > 0) {
                console.log('[DEBUG] Potentielle Geschenkprodukte:', potentialGiftProducts);
                console.log('[DEBUG] Potentielle Pflichtprodukte:', potentialRequiredProducts);
                
                const fallbackBlock = {
                  id: 'cart-fallback-block',
                  code: activeDiscountCode,
                  requiredProducts: potentialRequiredProducts.map(item => item.product_id),
                  giftProducts: potentialGiftProducts.map(item => item.product_id)
                };
                
                console.log('[DEBUG] Erstelle Fallback-Block:', fallbackBlock);
                discountGiftBlocks.push(fallbackBlock);
                
                // Verarbeite sofort den Fallback-Block
                processBlocks(discountGiftBlocks);
                return true; // Signalisiere, dass wir einen Block gefunden haben
              }
            }
            return false; // Signalisiere, dass wir keinen Block gefunden haben
          })
          .then(foundBlock => {
            if (!foundBlock) {
              console.log('[checkFreeDiscountProducts] Keine passenden Gift-Blöcke für den Rabattcode gefunden');
            }
          })
          .catch(error => {
            console.error('[checkFreeDiscountProducts] Fehler beim Verarbeiten des Fallbacks:', error);
          });
      }
    })
    .catch(error => {
      console.error('[checkFreeDiscountProducts] Fehler beim Abrufen des Warenkorbs:', error);
    });
};

// Event-Listener für Warenkorb-Aktualisierungen
document.addEventListener('DOMContentLoaded', function() {
  // Initialer Check nach dem Laden der Seite
  window.checkFreeDiscountProducts();
  
  // Bei Warenkorb-Aktualisierungen
  window.addEventListener('cart-update', function() {
    window.checkFreeDiscountProducts();
  });
  
  // Bei Warenkorb-Öffnung
  window.addEventListener('open-cart', function() {
    window.checkFreeDiscountProducts();
  });
});
